//one-card-sncallerdetails/card.tsx
//Import dependencies
import * as React from 'react';
import { useState,useEffect } from 'react';
import Button from 'antd/lib/button';
import Col from 'antd/lib/col';
import Row from 'antd/lib/row';
import Modal from 'antd/lib/modal';
import Table from 'antd/lib/table';
import Input from 'antd/lib/input';
import { SearchOutlined } from '@ant-design/icons';
import { Cell, Tooltip, Pie, PieChart } from 'recharts';
import PhoneIncoming from '@2fd/ant-design-icons/lib/PhoneIncoming';
import DialpadIcon from 'one-ui-graphics/svg/dialpad.svg';
import PersonCheckedIcon from 'one-ui-graphics/svg/person-checked.svg';
import DialpadOffIcon from 'one-ui-graphics/svg/dialpad-off.svg';
import PersonIcon from 'one-ui-graphics/svg/person.svg';
import DashIcon from 'one-ui-graphics/svg/dash.svg';
import ChevronUpIcon from 'one-ui-graphics/svg/chevron-up.svg';
import ChevronUpDoubleIcon from 'one-ui-graphics/svg/chevron-up-double.svg';
import ChevronDownIcon from 'one-ui-graphics/svg/chevron-down.svg';
import ChevronDownDoubleIcon from 'one-ui-graphics/svg/chevron-down-double.svg';
import Check from '@2fd/ant-design-icons/lib/Check';
import { useCtx } from 'one-ui-provider';
import { useSelector, useDispatch } from 'react-redux';
import classNames from 'classnames';
import {
  Card
} from 'one-ui-card/src/card';

import {
  ServiceNowCardProps
} from './props';

import {
  ServiceNowModal
} from './model';

import {
  CustomerDetail
} from 'one-state-servicenow-verify/src/ServicenowVerify';

import {
setSelectedAction as SelectedCaller
} from 'one-state-servicenow-verify/src/actions'

import Skeleton from 'antd/lib/skeleton';



/**
 *  card renders all ServiceNww caller related data
 * @param props component properties
 * @returns JSX code for ServiceNow caller
 */
export const ServiceNowCallerCard = <M extends ServiceNowModal>(
  props: ServiceNowCardProps<M>
) => {
  const {
    model,
    skeleton
  } = props;

  const {
    servicenowcaller,
  } = model || {};

  const {
    customerdetails_skeleton
  } = skeleton;

  const [keyword, setKeyword] = useState('');
  const [idkeyword, setIDKeyword] = useState('');
  const [disablename,setDisableName] = useState(false);
  const [disableid,setDisableID] = useState(false);
  const [modalvisible, setModalVisible] = useState(false);
  const incidentsinfo = useSelector((state:any)=> (state.getincidents));
  const [tabledata,setTableData] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState<CustomerDetail>();
  const colors = ['#CB4335', '#F1948A', '#3498DB', '#7DCEA0', '#229954'];
  const { resolver } = useCtx();
  let pieChartData:any = [];
  let summaryui ;
//To Check for Incident Data and fetch the Pie Chart Data
  if(incidentsinfo && incidentsinfo.length > 0) {
    pieChartData = [{
      name: '1 - Critical',
      value: incidentsinfo.filter((incident:any) => incident.priority === '1 - Critical').length,
    }, {
      name: '2 - High',
      value: incidentsinfo.filter((incident:any) => incident.priority === '2 - High').length,
    }, {
      name: '3 - Moderate',
      value: incidentsinfo.filter((incident:any) => incident.priority === '3 - Moderate').length,
    }, {
      name: '4 - Low',
      value: incidentsinfo.filter((incident:any) => incident.priority === '4 - Low').length,
    }, {
      name: '5 - Planning',
      value: incidentsinfo.filter((incident:any) => incident.priority === '5 - Planning').length,
    }];
  }

  const dispatch = useDispatch();
  const handleVerifysearchClick = () => {
    setModalVisible(true)
  }
// To disable the Modal when fetched data from the response.
  useEffect(() => {
    if (servicenowcaller) {
      if(servicenowcaller?.values?.length > 0) {
        let tableinfo:any = servicenowcaller.values;
        setTableData(tableinfo)
      }
      setModalVisible(true)
    }
}, [servicenowcaller]);
//Handler when we select a Employee 
  const onSelectCustomer = (row: CustomerDetail) => {

      dispatch(SelectedCaller(row))
      setSelectedCustomer(row);
      //To fetch Incident Information
      dispatch({
        type: "one-state-incidents/fetch",
        payload: {
          email: row?.email
        }
      });
      //To fetch Interaction Information
      dispatch({
        type: "one-state-interactions/fetch",
        payload: {
          email: row?.email
        }
      });
  };


  const handleCancel = (e: any) => {
    setModalVisible(false);
  };


  const onOk = () => {
    setModalVisible(false);
  };
//Handler when clicked on the Search Button
  const onSearch = () => {
    if(keyword && keyword !== '') {
      dispatch({
        type: "verify-caller",
        payload: {
          "callerdata": keyword
        }
      });
      dispatch({
        type: "one-state-skeleton/set",
        payload: {
          customerdetails_skeleton: true,
        }
      })
    }
    else if(idkeyword && idkeyword !== '') {
      dispatch({
        type: "verify-caller",
        payload: {
          "callerdata": idkeyword
        }
      });
      dispatch({
        type: "one-state-skeleton/set",
        payload: {
          customerdetails_skeleton: true,
        }
      })
    }
    
  };

  const onClear = () =>{
    setKeyword("");
    setIDKeyword("");
    setDisableID(false);
    setDisableName(false)
    setSelectedCustomer({})
  }

  const columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      rowKey: 'id',
    },
    {
      title: 'Name',
      dataIndex: 'name',
      rowKey: 'name',
    },
    {
      title: 'Email',
      dataIndex: 'email',
      rowKey: 'email',
    },
    {
      title: 'Address',
      dataIndex: 'location',
      rowKey: 'location',
      render: (value: any, row: CustomerDetail, index: any) => (
        <div>{row.street} {row.city} {row.zip}</div>
      ),
      ellipsis:true
    },
    {
      title: '',
      dataIndex: 'checked',
      rowKey: 'checked',
      render: (value: any, row: any, index: any) => (
        <div className={`p-verification__check ${classNames({ 'active': row.email === selectedCustomer?.email})}`}>
          <Check onClick={() => onSelectCustomer(row)} />
        </div>
      )
    },
  ];
//To check for the Matched Data

  if (selectedCustomer) {
    summaryui = (
      <>
        <div className="flex flex-column items-center caller-details">
          <div className="flex flex-col caller-details-verified">
            <div className="flex">
              <div className="caller-details-verified-phone-icon">
                <img
                  src={resolver(DialpadIcon)}
                  width={15}
                  height={15}
                  draggable="false"
                />
              </div>
              <div className="caller-details-verified-person-icon">
                <img
                  src={resolver(PersonCheckedIcon)}
                  width={15}
                  height={15}
                  draggable="false"
                />
              </div>
            </div>
            <div className="caller-details-verified-badge">Verified</div>
          </div>
          <div>
            <div className="flex items-center">
              <div className="caller-details-name">{selectedCustomer.name}</div>
              <Button
                type="link"
                className="caller-details-change-button"
                onClick={() => setModalVisible(true)}
              >Change</Button>
            </div>
            <div className="flex">
              <div className="caller-details-address">
                Address: <span>{selectedCustomer.street} {selectedCustomer.city} {selectedCustomer.zip}</span>
              </div>
            </div>
            <div className="caller-details-email">
              Email: <span>{selectedCustomer.email}</span>
            </div>
          </div>
        </div>
      </>
    )
  }
  //To Check for and No Match
  else {
    summaryui = (
      <>
        <div className="flex flex-column items-center caller-details">
          <div className="flex flex-col caller-details-verified">
            <div className="flex">
              <div className="caller-details-verified-phone-icon gray-border">
                <img
                  src={resolver(DialpadOffIcon)}
                  width={15}
                  height={15}
                  draggable="false"
                />
              </div>
              <div className="caller-details-verified-person-icon gray-border">
                <img
                  src={resolver(PersonIcon)}
                  width={15}
                  height={15}
                  draggable="false"
                />
              </div>
            </div>
          </div>
          <div>
            <Button
              type="primary"
              onClick={handleVerifysearchClick}
            >
              <PhoneIncoming />
              Verify Caller
            </Button>
          </div>
        </div>
      </>
    )
  }

  return (
    <>
      <Card
        title=''
        body={(
          <>
            <Row type="flex" justify="space-between" align="middle">
              <Col>
                <Row type="flex" gutter={[16, 0]}>
                  <Col>
                    {summaryui}
                  </Col>
                </Row>
              </Col>
              <Col>
                <Row type="flex" gutter={[16, 0]}>
                  <Col>
                    <div className="pie-chart-container">
                     {incidentsinfo && (
                       <PieChart height={100} width={100} margin={{ left: 0, top: 0, right: 0, bottom: 0 }}>
                       <Pie data={pieChartData} cx={40} cy={40} innerRadius={25} outerRadius={40} dataKey="value">
                         {pieChartData.map((entry, index) => (
                           <Cell key={index} fill={colors[index % colors.length]} />
                         ))}
                       </Pie>
                       <Tooltip />
                     </PieChart>
                     )
                     } 
                      <ul className="legends">
                        <li className="legends-item" style={{ color: colors[0] }}>
                          <img className="legends-item-image" src={resolver(ChevronUpDoubleIcon)} draggable="false" />
                          1 - Critical
                        </li>
                        <li className="legends-item" style={{ color: colors[1] }}>
                          <img className="legends-item-image" src={resolver(ChevronUpIcon)}draggable="false"/>
                          2 - High
                        </li>
                        <li className="legends-item" style={{ color: colors[2] }}>
                          <img className="legends-item-image" src={resolver(DashIcon)} draggable="false"/>
                          3 - Moderate
                        </li>
                        <li className="legends-item" style={{ color: colors[3] }}>
                          <img className="legends-item-image" src={resolver(ChevronDownIcon)} draggable="false"/>
                          4 - Low
                        </li>
                        <li className="legends-item" style={{ color: colors[4] }}>
                          <img className="legends-item-image" src={resolver(ChevronDownDoubleIcon)} draggable="false"/>
                          5 - Planning
                        </li>
                      </ul>
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
          </>
        )}
      />
      <Modal
        title={
          <div>Verify Caller <PhoneIncoming style={{ color: '#22C16E' }}  />{selectedCustomer && (<span>ID: {selectedCustomer.id}</span>)}</div>
        }
        visible={modalvisible}
        centered
        destroyOnClose
        onCancel={handleCancel}
        onOk={onOk}
        okText="Verify Caller"
        okButtonProps={{
          disabled: !selectedCustomer,
        }}
        cancelButtonProps={{ style: { display: 'none' } }}
        wrapClassName="custom-modal-wrap"
        width={650}
      >
        <Row gutter={[0, 16]}>
          <Col>
            <Row type="flex" gutter={[16, 16]}>
              <Col span={6}>
                <Input onChange={(event)=> setKeyword(event.target.value)} value={keyword} size="default" placeholder="ID" autoFocus={true} disabled = {disableid} onInput={(e:any)=> setDisableName(true)} suffix={<SearchOutlined />} />
              </Col>
              <Col span={6}>
                <Input onChange={(event)=> setIDKeyword(event.target.value)} value={idkeyword} size="default" placeholder="Name" disabled = {disablename} onInput={(e:any)=> setDisableID(true)} suffix={<SearchOutlined />} />
              </Col>
              <Col>
                <Button type="primary" onClick={onSearch}>Search</Button>
              </Col>
              <Col>
                <Button type="ghost" onClick={onClear}>Clear</Button>
              </Col>
            </Row>
          </Col>
          <Col>
          <Skeleton loading={skeleton?.customerdetails_skeleton} active paragraph={{ rows: 3 }}>
            <Table
              loading={customerdetails_skeleton}
              columns={columns}
              dataSource={tabledata}
              size="small"
              pagination={false}

            />
          </Skeleton>
          </Col>
        </Row>
      </Modal>
    </>
  );
};
